var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 21,
    viewBox: "0 0 15 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5487 10.1637L7.04549 16.7203L2.50811 10.1855C1.76428 8.70866 1.68438 6.94769 2.29099 5.40024C4.04849 0.916826 9.95134 0.901329 11.7347 5.38581C12.3475 6.92687 12.2791 8.68507 11.5487 10.1637ZM13.1983 11.1099L8.11425 18.8423L8.11353 18.8438L8.06422 18.9436L7.58734 19.6568C7.35035 20.1366 6.71297 20.1391 6.47233 19.6613L6.04378 18.9518L5.9937 18.8523L5.99297 18.8509L0.865787 11.1451C-0.149012 9.13017 -0.25802 6.7277 0.569567 4.61652C2.96992 -1.50681 11.0219 -1.51783 13.4522 4.59367C14.2878 6.69494 14.1949 9.09246 13.1983 11.1099ZM7.97776 7.38272C7.97912 7.9386 7.56193 8.39026 7.04594 8.39152C6.52994 8.39278 6.11054 7.94318 6.10918 7.3873C6.10782 6.83142 6.52501 6.37976 7.04101 6.3785C7.557 6.37723 7.9764 6.82684 7.97776 7.38272ZM9.84634 7.37814C9.85042 9.04579 8.59885 10.4008 7.05087 10.4045C5.50289 10.4083 4.24469 9.05952 4.2406 7.39187C4.23652 5.72423 5.48809 4.36926 7.03608 4.36547C8.58406 4.36168 9.84225 5.7105 9.84634 7.37814Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.0c4fa38c5cceca1bbdebda3ac9aee231.svg";
export { ForwardRef as ReactComponent };